import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import copperscrap from "../Images/copperscrap.png";
import almuniumscrap from "../Images/almuniumscrap.png";
import metal from "../Images/metal.png";
import { useNavigate } from "react-router-dom";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

const slides = [
  {
    image: copperscrap,
    title: "Scrap Copper Recovery",
    subtitle: "High-Value Metal Recycling",
  },
  {
    image: almuniumscrap,
    title: "Aluminium Scrap Processing",
    subtitle: "Lightweight Metal, Heavy Impact",
  },
  {
    image: metal,
    title: "Metal Recycling Industry",
    subtitle: "Sustainable Resource Recovery",
  },
];

const HeroCarousel = () => {
  const navigate = useNavigate();
  return (
    <>
      <style>
        {`
          .hero-swiper{
    width:100%;
    height:calc(100vh - 80px);
    min-height:600px;
}
.hero-slide{
    position:relative;
    width:100%;
    height:calc(100vh - 80px);
    min-height:600px;
    display:flex;
    align-items:center;
    justify-content:center;
    background-repeat:no-repeat;
    background-position:center;
    background-size:cover;
}

          .hero-slide{
            position:relative;
            width:100%;
            height:100vh;
            background-size:cover;
            background-position:center;
            display:flex;
            align-items:center;
            justify-content:center;
          }

         .hero-overlay{
    position:absolute;
    inset:0;
    background:linear-gradient(
        rgba(0,0,0,.55),
        rgba(0,0,0,.45)
    );
}

         .hero-content{
    position:relative;
    z-index:2;
    text-align:center;
    color:#fff;
    width:90%;
    max-width:900px;
    margin:auto;
    padding:20px;
}

        
        .hero-images{
            width:180px;
             height:auto;
              object-fit:contain;
              margin-bottom:20px;
        }

          .hero-title{
    font-size:clamp(2rem,5vw,4.5rem);
    font-weight:800;
    margin-bottom:20px;
    transition:.4s;
    cursor:pointer;
}
          .hero-title span{
            color:#c4ff1a;
          }
            .hero-title:hover{
    color:#FFD400;
}

         .hero-subtitle{
    font-size:clamp(1rem,2vw,1.5rem);
    color:#fff;
    margin-bottom:35px;
    transition:.4s;
    cursor:pointer;
}

.hero-subtitle:hover{
    color:#FFD400;
}

          .hero-btn{
    background:#FFD400;
    color:#0A2E73;
    border:none;
    padding:16px 38px;
    border-radius:50px;
    font-weight:700;
    cursor:pointer;
    transition:.4s;
}

      .hero-btn-contact{
    background:#0A2E73;
   color:white;
   margin-left:10px;
    border:none;
    padding:16px 38px;
    border-radius:50px;
    font-weight:700;
    cursor:pointer;
    transition:.4s;
    
}
    /* Mobile */
@media (max-width: 768px) {
  .hero-btn-contact {
    margin-top: 12px;
    margin-left: 0;
  }
}

.hero-btn-contact:hover{
    background:white;
    color:#0A2E73;
    transform:translateY(-5px);
    box-shadow:0 15px 35px rgba(255,212,0,.45);
}

.hero-btn:hover{
    background:white;
    color:#0A2E73;
    transform:translateY(-5px);
    box-shadow:0 15px 35px rgba(255,212,0,.45);
}
         @media (max-width:1200px){

.hero-swiper,
.hero-slide{
    min-height:550px;
}

}
@media (max-width:1440px){

.hero-swiper,
.hero-slide{
    height:85vh;
}

}
@media (max-width:1200px){

.hero-title{
    font-size:3.5rem;
}

.hero-subtitle{
    font-size:1.2rem;
}

}
@media (max-width:1024px){

.hero-swiper,
.hero-slide{
    height:75vh;
}

.hero-title{
    font-size:3rem;
}

.hero-subtitle{
    font-size:1.1rem;
}

}
@media (max-width:992px){

.hero-swiper,
.hero-slide{
    min-height:500px;
}

.hero-title{
    font-size:3rem;
}

.hero-subtitle{
    font-size:1.2rem;
}

}
@media (max-width:820px){

.hero-swiper,
.hero-slide{
    height:70vh;
}

.hero-title{
    font-size:2.4rem;
}

.hero-subtitle{
    font-size:1rem;
}

.hero-btn{
    padding:14px 30px;
}

}

@media (max-width:768px){

.hero-swiper,
.hero-slide{
    height:75vh;
    min-height:450px;
}

.hero-title{
    font-size:2.3rem;
}

.hero-subtitle{
    font-size:1rem;
}

.hero-btn{
    padding:14px 28px;
}

}
@media (max-width:540px){

.hero-swiper,
.hero-slide{
    height:65vh;
    min-height:420px;
}

.hero-content{
    width:94%;
}

.hero-title{
    font-size:2rem;
}

.hero-subtitle{
    font-size:.95rem;
}

.hero-btn{
    width:180px;
    padding:13px 0;
}

}

@media (max-width:576px){

.hero-swiper,
.hero-slide{
    height:70vh;
    min-height:400px;
}

.hero-title{
    font-size:1.8rem;
}

.hero-subtitle{
    font-size:.95rem;
}

.hero-btn{
    width:200px;
}

}

@media (max-width:360px){

.hero-title{
    font-size:1.5rem;
}

.hero-subtitle{
    font-size:.85rem;
}

.hero-btn{
    width:160px;
    font-size:14px;
}

}
@media (max-width:420px){

.hero-swiper,
.hero-slide{
    height:60vh;
    min-height:380px;
}

.hero-title{
    font-size:1.7rem;
}

.hero-subtitle{
    font-size:.9rem;
}

.hero-btn{
    width:170px;
    font-size:15px;
}

}

        `}
      </style>

      <Swiper
        modules={[Autoplay, Pagination, EffectFade]}
        effect="fade"
        loop={true}
        speed={1200}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        className="hero-swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="hero-slide"
              style={{
                backgroundImage: `url(${slide.image})`,
              }}
            >
              <div className="hero-overlay"></div>

              <div className="hero-content">
                {/* <img
                  src={slide.image}
                  alt={slide.title}
                  className="hero-images"
                /> */}

                <h1 className="hero-title">{slide.title}</h1>

                <p className="hero-subtitle">{slide.subtitle}</p>
                <button className="hero-btn" onClick={() => navigate("/about")}>
                  Learn More
                </button>

                <button
                  className="hero-btn-contact"
                  onClick={() => navigate("/contact")}
                >
                  Contact Us
                </button>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default HeroCarousel;
